// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../types.tsx';

const run =
	<T extends State>(key: string, ...args: unknown[]): Action<T> =>
	({ getState }): void =>
		// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
		(getState()[key] || new Set()).forEach((cb) => cb(...args));

export default run;
